import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Bridge } from '../models/Bridge';

@Injectable({
  providedIn: 'root'
})
export class BridgeService {


  constructor(private httpClient: HttpClient) { }

  findAll(): Observable<Bridge[]> {
    return this.httpClient.get<Bridge[]>(environment.apiUrl + "bridges");
  }
}
